import React, { Component } from "react";
import MetaTags from "react-meta-tags";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { getLeads } from "../../../store/actions";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  CardHeader
} from "reactstrap";
import { Accordion, AccordionItem, AccordionHeader, AccordionBody } from "reactstrap";
import FilterMenu from "./filter-menu";
import Moment from "react-moment";
import Slider from "react-slick";

class LeadEngageMentView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activites: [],
      brColor: [
        { borderBottom: "3px solid #0D6EFD" },
        { borderBottom: "3px solid #198754" },
        { borderBottom: "3px solid #0DCAF0" },
        { borderBottom: "3px solid #AB2E3C" },
        { borderBottom: "3px solid #FFC107" }
      ],
      localization: {},
      isMobile: window.innerWidth < 768,
    };
  }

 componentDidMount() {
  const { onGetAllLeads } = this.props;
  const userId = localStorage.getItem("userId");

  // Fetch leads (no .then())
  onGetAllLeads(userId);

  // Load localization
  const allLocal = localStorage.getItem("localData");
  const localization = allLocal ? JSON.parse(allLocal) : {};
  this.setState({ localization });
   window.addEventListener("resize", () => {
        this.setState({ isMobile: window.innerWidth < 768 });
  });
}

componentDidUpdate(prevProps) {
  // Initialize activities when leads are fetched/updated
  if (prevProps.allLeads !== this.props.allLeads) {
    this.initializeActivities();
  }
}

  realtorDate(isoDate) {
    let date = new Date(isoDate);
    let dtString = date.getDate() < 10 ? "0" + date.getDate() : String(date.getDate());
    let monthString = date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : String(date.getMonth() + 1);
    return date.getFullYear() + "-" + monthString + "-" + dtString;
  }

  getDateFromTodayPlus(numberOfDays) {
    const d = new Date();
    d.setDate(d.getDate() + numberOfDays);
    return this.realtorDate(d);
  }

  initializeActivities = () => {
    const { allLeads } = this.props;
    if (!allLeads || !allLeads.length) return;

    const lastSevenDay = this.getDateFromTodayPlus(-7);
    const lastEightDay = this.getDateFromTodayPlus(-8);
    const lastFigteenDay = this.getDateFromTodayPlus(-15);
    const lastSixteenDay = this.getDateFromTodayPlus(-16);
    const lastTwentyThreeDay = this.getDateFromTodayPlus(-23);
    const lastTwentyFourDay = this.getDateFromTodayPlus(-24);
    const lastThirtDay = this.getDateFromTodayPlus(-30);

    const activites = [
      {
        title: "Last 7 Days",
        leads: allLeads.filter(
          (d) => d.lastActivity && lastSevenDay <= this.realtorDate(d.lastActivity)
        )
      },
      {
        title: "8-15 Days",
        leads: allLeads.filter(
          (d) =>
            d.lastActivity &&
            lastEightDay >= this.realtorDate(d.lastActivity) &&
            lastFigteenDay <= this.realtorDate(d.lastActivity)
        )
      },
      {
        title: "16-23 Days",
        leads: allLeads.filter(
          (d) =>
            d.lastActivity &&
            lastSixteenDay >= this.realtorDate(d.lastActivity) &&
            lastTwentyThreeDay <= this.realtorDate(d.lastActivity)
        )
      },
      {
        title: "24-30 Days",
        leads: allLeads.filter(
          (d) =>
            d.lastActivity &&
            lastTwentyFourDay >= this.realtorDate(d.lastActivity) &&
            lastThirtDay <= this.realtorDate(d.lastActivity)
        )
      },
      {
        title: "No Activity in 30 Days",
        leads: allLeads.filter(
          (d) => d.lastActivity && lastThirtDay > this.realtorDate(d.lastActivity)
        )
      }
    ];

    this.setState({ activites });
  };



  render() {
    const { gridLoading } = this.props;
    const { activites, brColor } = this.state;
const renderMobileActivitiesAccordion = () => {
  return (
    <Accordion
      open={this.state.openActivity}
      toggle={(id) =>
        this.setState({
          openActivity: this.state.openActivity === id ? null : id,
        })
      }
    >
      {activites.map((activite, index) => (
        <AccordionItem key={activite.title}>
          <AccordionHeader targetId={activite.title} style={brColor[index]}>
            {activite.title} 
            {/* ({activite.leads.length}) */}
          </AccordionHeader>
          <AccordionBody accordionId={activite.title}>
            {activite.leads.map((lead) => (
              <Card className="custom-card mt-2" key={lead.id}>
                <CardBody>
                  <div className="float-end ms-2">
                    <span className="badge rounded-pill badge-soft-success font-size-12">
                      {lead.leadStatusId
                        ? this.state.localization["LeadStatus_" + lead.leadStatusId]
                        : "N/A"}
                    </span>
                  </div>
                  <h5 className="card-title mb-2 lead-box-title">
                    <Link to={`/lead/lead-detail/${lead.id}/${lead.leadId}`}>
                      {lead.firstName} {lead.lastName}
                    </Link>
                  </h5>
                  <div className="mt-1">
                    <i className="bx bx-calendar align-middle"></i> :{" "}
                    {lead.lastActivity ? (
                      <Moment format="D MMM YY">{lead.lastActivity}</Moment>
                    ) : (
                      "—"
                    )}
                  </div>
                  <div className="mt-1">
                    <i className="bx bx-run align-middle"></i> :{" "}
                    {lead.lastActivityType || "No Activity"}
                  </div>
                </CardBody>
              </Card>
            ))}
          </AccordionBody>
        </AccordionItem>
      ))}
    </Accordion>
  );
};
    return (
      <React.Fragment>
        {gridLoading ? (
          <div className="rs-loader-overlay">
            <div className="rs-loader"></div>
          </div>
        ) : null}
        <ToastContainer autoClose={2000} />
        <div className="page-content project-page-content">
          <MetaTags>
            <title>Engagement View | Realty Space</title>
          </MetaTags>
          <Container fluid className="ps-0 pe-0">
            <Card className="card-without-border">
              <CardHeader>
                <FilterMenu />
              </CardHeader>
            </Card>

            {/* Desktop View */}
             
              <Card>
                <CardBody>
                    {this.state.isMobile ? (
                         renderMobileActivitiesAccordion() 
                    ) : (
              <Row className="toHeadingRow">
                {activites.map((activite, index) => (
                  <Col md="2" key={activite.title}>
                    <div className="topHeading" style={brColor[index]}>
                      <span className="sc-kEqXSa CIzYb">{activite.title}</span>
                    </div>
                    {activite.leads.map((lead) => (
                      <Card className="custom-card mt-2" key={lead.id}>
                        <CardBody>
                          <div className="float-end ms-2">
                            <span className="badge rounded-pill badge-soft-success font-size-12">
                              {lead.leadStatusId
                                ? this.state.localization["LeadStatus_" + lead.leadStatusId]
                                : "N/A"}
                            </span>
                          </div>
                          <h5 className="card-title mb-2 lead-box-title">
                            <Link to={`/lead/lead-detail/${lead.id}/${lead.leadId}`}>
                              {lead.firstName} {lead.lastName}
                            </Link>
                          </h5>
                          <div className="mt-1">
                            <i className="bx bx-calendar align-middle"></i> :{" "}
                            {lead.lastActivity ? (
                              <Moment format="D MMM YY">{lead.lastActivity}</Moment>
                            ) : (
                              ""
                            )}
                          </div>
                          <div className="mt-1">
                            <i className="bx bx-run align-middle"></i> :{" "}
                            {lead.lastActivityType || "No Activity"}
                          </div>
                        </CardBody>
                      </Card>
                    ))}
                  </Col>
                ))}
              </Row>
                )}
              </CardBody>
              </Card>
          

           
           
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

LeadEngageMentView.propTypes = {
  t: PropTypes.any,
  onGetAllLeads: PropTypes.func,
  allLeads: PropTypes.array,
  gridLoading: PropTypes.bool
};

const mapStateToProps = ({ leads }) => ({
  allLeads: leads.allLeads,
  gridLoading: leads.gridLoading
});

const mapDispatchToProps = (dispatch) => ({
  onGetAllLeads: (agentId) => dispatch(getLeads(agentId))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(LeadEngageMentView));
